import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { ImageCard } from '@/components/Dico';
import Image from '@/components/Image/Image';
import { URLS } from '@/constants/urls';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

const PrivateStockExchangeAccess: React.FC = () => {
  const { t } = useTranslation();

  const handleClick = () => {
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'bourse privee connexion',
      event_detail_1: 'cta',
      event_detail_2: 'bourse privee',
    });
    globalThis.open(URLS.PRIVATE_STOCK_EXCHANGE_URL, '_blank', 'noopener');
  };

  return (
    <div className={styles.privateStockExchangeAccess}>
      <div className={styles.imageWrapper}>
        <Image
          defaultSrc={ImageCard.IMAGE_CARD_BOURSE_DEFAULT}
          webpSrc={ImageCard.IMAGE_CARD_BOURSE_WEBP}
          alt=""
          className={styles.image}
        />
      </div>

      <div className={styles.content}>
        <div className={styles.title}>
          <span>{t('autresAcces.bourseSpaceLabel')}</span>
          <strong>{t('autresAcces.bourseSubscriptionLabel')}</strong>
        </div>

        <MtxButton onClick={handleClick} variant="tertiary" size="medium" className={styles.button}>
          <div>{t('autresAcces.bourseButtonLabel')}</div>
          <div slot="end-icon" className={styles.externalLinkIcon}>
            <i className="totem-icon totem-icon-external-link" />
          </div>
        </MtxButton>
      </div>
    </div>
  );
};

export default PrivateStockExchangeAccess;
